var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('LoaderReport') : _c('layout-report', [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "justify-center align-center pl-md-16"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "display-1 text--primary"
  }, [_vm._v(_vm._s(_vm.title))])])], 1), _vm._l(_vm.items, function (item, i) {
    return _c('v-row', {
      key: i,
      staticClass: "pl-6 "
    }, [_c('v-col', {
      staticClass: "pl-0",
      attrs: {
        "cols": "1"
      }
    }, [_c('v-icon', {
      domProps: {
        "textContent": _vm._s(item.icon)
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "11"
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])], 1);
  }), _c('v-row', {
    staticClass: "pl-6"
  }, [_c('v-btn', {
    attrs: {
      "id": "start",
      "dark": "",
      "color": "success",
      "x-large": "",
      "outlined": "",
      "data-test-report-start": ""
    },
    on: {
      "click": _vm.start
    }
  }, [_vm._v(" Zur Schadensmeldung ")])], 1)], 2), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "src": require("@/assets/undraw_towing_6yy4.svg"),
      "dark": ""
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }